import React from 'react'
import AnimationLink from './Link'
import arrowBlue from '../assets/images/arrow-small-blue.svg'
import arrowWhite from '../assets/images/arrow-small-white.svg'

const CONTACT_PATH = { en: '/en/contact-us/', pt: '/contacte-nos/' }
/** Match `$lets-talk-arrow-px` in `src/assets/scss/pages/_lets-talk-cta.scss` */
const ARROW_IMG_PX = 15

const LetsTalkCta = ({
  isEn,
  hex,
  tone = 'accent',
  className = '',
  paintDrip = true,
  to: toOverride,
  label: labelOverride,
  ...rest
}) => {
  const to = toOverride ?? (isEn ? CONTACT_PATH.en : CONTACT_PATH.pt)
  const label =
    labelOverride ?? (isEn ? "Let's talk" : 'Contacte-nos')
  const arrowSrc = tone === 'onDark' ? arrowWhite : arrowBlue
  const toneClass = tone === 'onDark' ? 'lets-talk-cta--on-dark' : 'lets-talk-cta--accent'
  const cls = ['lets-talk-cta', toneClass, className].filter(Boolean).join(' ')

  return (
    <AnimationLink paintDrip={paintDrip} hex={hex} to={to} className={cls} {...rest}>
      <span className="lets-talk-cta__label">{label}</span>
      <span className="lets-talk-cta__arrow" aria-hidden="true">
        <img src={arrowSrc} alt="" width={ARROW_IMG_PX} height={ARROW_IMG_PX} decoding="async" />
      </span>
    </AnimationLink>
  )
}

export default LetsTalkCta
